import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ResponsiveService } from '../../../services/responsive.service';
import { LogoutValidation } from '../logout-validation/logout-validation';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar-item',
  imports: [CommonModule,RouterModule],
  templateUrl: './sidebar-item.html',
  styleUrl: './sidebar-item.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarItem {
  @Input() link: string= '';
  @Input() icon: string= '';
  @Input() iconChosen: string= '';
  @Input() label: string = '';
  isMobile: boolean = false;
  clickedItem : Boolean = false;
  dialogRef: any;
  private routerSubscription: Subscription;

	constructor(private responsiveService: ResponsiveService,private router: Router,
		private dialog: MatDialog, private cdr: ChangeDetectorRef) {
		this.routerSubscription = router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((event: NavigationEnd) => {
			if(event.urlAfterRedirects){
				const wasClickedItem = this.clickedItem;
				if(event.urlAfterRedirects.includes('newinstallationwizard')){
					this.clickedItem = true;
				}else{
					this.clickedItem = false;	
				}
				if(wasClickedItem !== this.clickedItem){
					this.cdr.detectChanges();
				}
			}		
		})
	}

	ngOnInit(){		
		this.clickedItem = this.router.url.includes('newinstallationwizard');
		this.onResize();
		this.responsiveService.checkWidth();
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

	onReqToLink(link:any){		
		this.dialogRef = this.dialog.open(LogoutValidation, {
			width: '600px',
			disableClose: true
			});

			this.dialogRef.afterClosed().subscribe((result:any) => {
			if (result == true) {
				this.router.navigate([link]);
			}
		});		
	}

	ngOnDestroy() {
		if(this.routerSubscription){
			this.routerSubscription.unsubscribe();
		}
	}
}
